//(()=>{var e={113:(e,t,r)=>{"use strict";var n=r(58),o=r(713),i=r.n(o);function s(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}var a={mergeDeepObject:function(){for(var e=e=>e&&"object"==typeof e,t=arguments.length,r=new Array(t),n=0;n<t;n++)r[n]=arguments[n];return r.reduce(((t,r)=>(Object.keys(r).forEach((n=>{var o=t[n],i=r[n];Array.isArray(o)&&Array.isArray(i)?t[n]=[...new Set([...i,...o])]:e(o)&&e(i)?t[n]=a.mergeDeepObject(o,i):t[n]=i})),t)),{})},debounce(e,t){var r,n=this;return function(){for(var o=arguments.length,i=new Array(o),s=0;s<o;s++)i[s]=arguments[s];window.clearTimeout(r),r=window.setTimeout((()=>e.apply(n,i)),t)}},uniqueID(){var e=Math.random().toString(36).substr(2);return Date.now().toString(36)+e},setPropertyCss(e,t,r){0!==e.length&&e.forEach(((e,n)=>{e.style.setProperty(t,r)}))},classElements(e,t){var r="height-zero",n="height-calculating",o="height-calculated";e.forEach(((e,i)=>{e.classList.remove(r),e.classList.remove(n),e.classList.remove(o),"calculating"===t&&e.classList.add(n),"complete"===t&&e.classList.add(o),"complete-zero"===t&&e.classList.add(r)}))}},l=function(e){if(e){var t,r={},n=!1,o=[],l=function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?s(Object(r),!0).forEach((function(t){i()(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):s(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}({defaultColumns:4,resizeDelay:0,responsive:{1440:4,834:3,680:2},init:e=>{},afterBreakpoint:e=>{}},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{}),c=()=>{e.setAttribute("data-breakpoint",r.breakpoint),e.setAttribute("data-columns",r.columns)},d=()=>{e.querySelectorAll(".light-masonry-item").forEach((t=>{e.querySelector(".light-masonry-hidden-box").appendChild(t)}))},u=()=>{e.querySelectorAll(".light-masonry-column").forEach((e=>{e.remove()}))},h=t=>{for(var r=1;r<=t;r++)e.insertAdjacentHTML("beforeend",'<div class="light-masonry-column"></div>')},m=()=>{var t=[];e.querySelectorAll(".light-masonry-item").forEach((e=>{t.push(e.dataset.index)})),o=t.sort(((e,t)=>e-t));for(var r=t=>{o.length&&(t.appendChild(e.querySelector('.light-masonry-item[data-index="'.concat(o[0],'"]'))),o.shift())};o.length;)e.querySelectorAll(".light-masonry-column").forEach(r)},p=()=>{var e,t=l.defaultColumns;r.breakpoint="defaultColumns",void 0!==l.responsive&&Object.keys(l.responsive).reverse().forEach((e=>{window.innerWidth>Number(e)||(r.breakpoint=Number(e),t=l.responsive[e])})),r.columns===t?(r.columns=t,n||(d(),u(),h(t),m(),c())):(r.columns=t,d(),u(),h(t),m(),c(),e=r,n&&l.afterBreakpoint(e))};e.classList.add("light-masonry-wrapper"),Array.from(e.children).forEach((e=>{e.classList.add("light-masonry-item")})),e.querySelectorAll(".light-masonry-item").forEach(((e,t)=>{e.dataset.index=t})),e.insertAdjacentHTML("beforeend",'<div class="light-masonry-hidden-box" style="display: none !important;"></div>'),p(),e.classList.add("light-masonry-initialized"),t=r,n||(l.init(t),n=!0),0===l.resizeDelay?window.addEventListener("resize",p):window.addEventListener("resize",a.debounce(p,l.resizeDelay))}else window.console.error("Elemento no encontrado: ".concat(e))};window.lightMasonry=l;var c=l,d=(r(622),r(755));(0,n.z2)("header-section",{setCssProperties(){var e=d("#shopify-section-announcement-bar").height();document.documentElement.style.setProperty("--announcement-bar-height","".concat(e,"px"));var t=d("#shopify-section-header").height();document.documentElement.style.setProperty("--header-height","".concat(t,"px")),document.documentElement.style.setProperty("--full-header-height","".concat(e+t,"px"));var r=window.innerHeight;document.documentElement.style.setProperty("--viewport-height","".concat(r,"px"))},addClassToScroll(){var e=document.querySelector(".header-main-wrapper"),t=!1,r=0;function n(){!t&&window.scrollY>10?(e.classList.add("header-with-scroll"),t=!0):t&&window.scrollY<10&&(e.classList.remove("header-with-scroll"),t=!1)}var o=()=>{window.scrollY>70&&window.scrollY>r&&e.classList.add("header-hide-elements"),window.scrollY<r&&e.classList.remove("header-hide-elements"),r=window.scrollY};n(),o(),window.addEventListener("scroll",(()=>{n(),o()}))},configResizeMobileMenu(){if(!(window.innerWidth<=this.mobileMediaQuery)){var e=document.querySelector(".menu-drawer-container");e.classList.contains("menu-opening")&&e.querySelector(".header-button-container").click()}},configSubmenuDesktop(){var e="header-menu-item-submenu-open",t=this.container.querySelectorAll(".header-menu-item.header-menu-item-has-submenu");t.forEach((t=>{t.querySelector(".header-menu-link").addEventListener("click",(r=>{window.innerWidth>=835||window.innerWidth<this.mobileMediaQuery||(r.preventDefault(),t.classList.toggle(e))}))})),document.addEventListener("click",(r=>{var n=r.target;t.forEach((t=>{t.classList.contains(e)&&t.contains(n)||t.classList.remove(e)}))})),window.addEventListener("resize",(()=>{window.innerWidth>=835&&t.forEach((t=>{t.classList.remove(e)}))}))},configMegamenus(){this.container.querySelectorAll(".header-megamenu").forEach((e=>{var t=Number(e.querySelector("[data-total-columns]").dataset.totalColumns),r={defaultColumns:t<=6?t:6,responsive:{1023:t<=5?t:5,833:t<=4?t:4}};c(e.querySelector(".header-megamenu-items"),r)}))},addEventResize(){window.addEventListener("resize",debounce((()=>{this.setCssProperties(),this.configResizeMobileMenu()}),100))},addEventScroll(){window.addEventListener("scroll",debounce((()=>{this.setCssProperties()}),60))},onLoad(){this.mobileMediaQuery=710,this.addClassToScroll(),this.addEventResize(),this.addEventScroll(),this.setCssProperties(),this.configSubmenuDesktop(),this.configMegamenus()}}),document.addEventListener("DOMContentLoaded",(()=>{(0,n.zD)("*")})),r(4),document.addEventListener("DOMContentLoaded",(()=>{(0,n.zD)("*")}))},4:()=>{window.getImageMaxHeight=()=>{var e=document.querySelectorAll(".product-card .product-card-image-wrapper");e.length&&e.forEach((e=>{e.style.setProperty("--height","".concat(e.offsetHeight,"px"))}))},window.getImageMaxHeight(),window.addEventListener("resize",window.getImageMaxHeight)}},t={};function r(n){if(t[n])return t[n].exports;var o=t[n]={exports:{}};return e[n].call(o.exports,o,o.exports,r),o.exports}r.m=e,r.x=e=>{},r.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return r.d(t,{a:t}),t},r.d=(e,t)=>{for(var n in t)r.o(t,n)&&!r.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r.j=348,(()=>{var e={348:0},t=[[113,351]],n=e=>{},o=(o,i)=>{for(var s,a,[l,c,d,u]=i,h=0,m=[];h<l.length;h++)a=l[h],r.o(e,a)&&e[a]&&m.push(e[a][0]),e[a]=0;for(s in c)r.o(c,s)&&(r.m[s]=c[s]);for(d&&d(r),o&&o(i);m.length;)m.shift()();return u&&t.push.apply(t,u),n()},i=self.webpackChunkgetmore_workflow=self.webpackChunkgetmore_workflow||[];function s(){for(var n,o=0;o<t.length;o++){for(var i=t[o],s=!0,a=1;a<i.length;a++){var l=i[a];0!==e[l]&&(s=!1)}s&&(t.splice(o--,1),n=r(r.s=i[0]))}return 0===t.length&&(r.x(),r.x=e=>{}),n}i.forEach(o.bind(null,0)),i.push=o.bind(null,i.push.bind(i));var a=r.x;r.x=()=>(r.x=a||(e=>{}),(n=s)())})(),r.x()})();

(() => {
  var e = {
      113: (e, t, r) => {
        "use strict";
        var n = r(58),
          o = r(713),
          i = r.n(o);

        function s(e, t) {
          var r = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter((function(t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable
            }))), r.push.apply(r, n)
          }
          return r
        }
        var a = {
            mergeDeepObject: function() {
              for (var e = e => e && "object" == typeof e, t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
              return r.reduce(((t, r) => (Object.keys(r).forEach((n => {
                var o = t[n],
                  i = r[n];
                Array.isArray(o) && Array.isArray(i) ? t[n] = [...new Set([...i, ...o])] : e(o) && e(i) ? t[n] = a.mergeDeepObject(o, i) : t[n] = i
              })), t)), {})
            },
            debounce(e, t) {
              var r, n = this;
              return function() {
                for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++) i[s] = arguments[s];
                window.clearTimeout(r), r = window.setTimeout((() => e.apply(n, i)), t)
              }
            },
            uniqueID() {
              var e = Math.random().toString(36).substr(2);
              return Date.now().toString(36) + e
            },
            setPropertyCss(e, t, r) {
              0 !== e.length && e.forEach(((e, n) => {
                e.style.setProperty(t, r)
              }))
            },
            classElements(e, t) {
              var r = "height-zero",
                n = "height-calculating",
                o = "height-calculated";
              e.forEach(((e, i) => {
                e.classList.remove(r), e.classList.remove(n), e.classList.remove(o), "calculating" === t && e.classList.add(n), "complete" === t && e.classList.add(o), "complete-zero" === t && e.classList.add(r)
              }))
            }
          },
          l = function(e) {
            if (e) {
              var t, r = {},
                n = !1,
                o = [],
                l = function(e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var r = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? s(Object(r), !0).forEach((function(t) {
                      i()(e, t, r[t])
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s(Object(r)).forEach((function(t) {
                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
                    }))
                  }
                  return e
                }({
                  defaultColumns: 4,
                  resizeDelay: 0,
                  responsive: {
                    1440: 4,
                    834: 3,
                    680: 2
                  },
                  init: e => {},
                  afterBreakpoint: e => {}
                }, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}),
                c = () => {
                  e.setAttribute("data-breakpoint", r.breakpoint), e.setAttribute("data-columns", r.columns)
                },
                d = () => {
                  e.querySelectorAll(".light-masonry-item").forEach((t => {
                    e.querySelector(".light-masonry-hidden-box").appendChild(t)
                  }))
                },
                u = () => {
                  e.querySelectorAll(".light-masonry-column").forEach((e => {
                    e.remove()
                  }))
                },
                h = t => {
                  for (var r = 1; r <= t; r++) e.insertAdjacentHTML("beforeend", '<div class="light-masonry-column"></div>')
                },
                m = () => {
                  var t = [];
                  e.querySelectorAll(".light-masonry-item").forEach((e => {
                    t.push(e.dataset.index)
                  })), o = t.sort(((e, t) => e - t));
                  for (var r = t => {
                      o.length && (t.appendChild(e.querySelector('.light-masonry-item[data-index="'.concat(o[0], '"]'))), o.shift())
                    }; o.length;) e.querySelectorAll(".light-masonry-column").forEach(r)
                },
                p = () => {
                  var e, t = l.defaultColumns;
                  r.breakpoint = "defaultColumns", void 0 !== l.responsive && Object.keys(l.responsive).reverse().forEach((e => {
                    window.innerWidth > Number(e) || (r.breakpoint = Number(e), t = l.responsive[e])
                  })), r.columns === t ? (r.columns = t, n || (d(), u(), h(t), m(), c())) : (r.columns = t, d(), u(), h(t), m(), c(), e = r, n && l.afterBreakpoint(e))
                };
              e.classList.add("light-masonry-wrapper"), Array.from(e.children).forEach((e => {
                e.classList.add("light-masonry-item")
              })), e.querySelectorAll(".light-masonry-item").forEach(((e, t) => {
                e.dataset.index = t
              })), e.insertAdjacentHTML("beforeend", '<div class="light-masonry-hidden-box" style="display: none !important;"></div>'), p(), e.classList.add("light-masonry-initialized"), t = r, n || (l.init(t), n = !0), 0 === l.resizeDelay ? window.addEventListener("resize", p) : window.addEventListener("resize", a.debounce(p, l.resizeDelay))
            } else window.console.error("Elemento no encontrado: ".concat(e))
          };
        window.lightMasonry = l;
        var c = l,
          d = (r(622), r(755));
        (0, n.z2)("header-section", {
          setCssProperties() {
            var e = d("#shopify-section-announcement-bar").height();
            document.documentElement.style.setProperty("--announcement-bar-height", "".concat(e, "px"));
            var t = d("#shopify-section-header").height();
            document.documentElement.style.setProperty("--header-height", "".concat(t, "px")), document.documentElement.style.setProperty("--full-header-height", "".concat(e + t, "px"));
            var r = window.innerHeight;
            document.documentElement.style.setProperty("--viewport-height", "".concat(r, "px"))
          },
          addClassToScroll() {
            var e = document.querySelector(".header-main-wrapper"),
                t = !1,
                r = 0;
            var hd = document.querySelector(".header-main-wrapper");

            function n() {
              if (!t && window.scrollY > 10) {
                e.classList.add("header-with-scroll");
                t = !0;
              } else if (t && window.scrollY < 10) {
                e.classList.remove("header-with-scroll");
                t = !1;
              }


              if (window.scrollY > 180) {
                setTimeout(function() {
                    let xy = document.querySelector(".boost-sd__filter-block .boost-sd__toolbar-container");
                    if (xy) xy.classList.add("filter-with-scroll");
                }, 50);
              } else if (window.scrollY < 180) {
                setTimeout(function() {
                    let xy = document.querySelector(".boost-sd__filter-block .boost-sd__toolbar-container");
                    let ht = hd.offsetHeight;
                    if (xy) {
                      xy.style.top = (ht - 2) + "px";
                      xy.classList.remove("filter-with-scroll");
                    }
                }, 50);
              }


              if (window.scrollY > 50) {
                setTimeout(function() {                  
                    let xyz = document.querySelector(".main-product-nav-mobile");
                    if (xyz) xyz.classList.add("filter-with-scroll");
                }, 50);
              } else if (window.scrollY < 50) {
                setTimeout(function() {
                    let xyz = document.querySelector(".main-product-nav-mobile");
                    let ht = hd.offsetHeight;
                    if (xyz) {
                      xyz.style.top = (ht - 2) + "px";
                      xyz.classList.remove("filter-with-scroll");
                    }
                }, 50);
              }
            }

            var o = () => {
              if (window.scrollY > 70 && window.scrollY > r) {
                e.classList.add("header-hide-elements");
              } else if (window.scrollY < r) {
                e.classList.remove("header-hide-elements");
              }


              if (window.scrollY > 180 && window.scrollY > r) {
                setTimeout(function() {
                    let xy = document.querySelector(".boost-sd__filter-block .boost-sd__toolbar-container");
                    if (xy) xy.classList.add("filter-hide-elements");
                }, 50);
              } else if (window.scrollY < r) {
                setTimeout(function() {
                    let xy = document.querySelector(".boost-sd__filter-block .boost-sd__toolbar-container");
                    let ht = hd.offsetHeight;
                    if (xy) {
                      xy.style.top = (ht - 2) + "px";
                      xy.classList.remove("filter-hide-elements");
                    }
                }, 50);
              }


              if (window.scrollY > 50 && window.scrollY > r) {
                setTimeout(function() {
                    let xyz = document.querySelector(".main-product-nav-mobile");
                    if (xyz) xyz.classList.add("filter-hide-elements");
                }, 50);
              } else if (window.scrollY < r) {
                setTimeout(function() {
                    let xyz = document.querySelector(".main-product-nav-mobile");
                    let ht = hd.offsetHeight;
                    if (xyz) {
                      xyz.style.top = (ht - 2) + "px";
                      xyz.classList.remove("filter-hide-elements");
                    }
                }, 50);
              }
              r = window.scrollY;
            };

            n();
            o();
            window.addEventListener("scroll", (() => {
              n();
              o();
            }));
          },
          configResizeMobileMenu() {
            if (!(window.innerWidth <= this.mobileMediaQuery)) {
              var e = document.querySelector(".menu-drawer-container");
              e.classList.contains("menu-opening") && e.querySelector(".header-button-container").click()
            }
          },
          configSubmenuDesktop() {
            var e = "header-menu-item-submenu-open",
              t = this.container.querySelectorAll(".header-menu-item.header-menu-item-has-submenu");
            t.forEach((t => {
              t.querySelector(".header-menu-link").addEventListener("click", (r => {
                window.innerWidth >= 835 || window.innerWidth < this.mobileMediaQuery || (r.preventDefault(), t.classList.toggle(e))
              }))
            })), document.addEventListener("click", (r => {
              var n = r.target;
              t.forEach((t => {
                t.classList.contains(e) && t.contains(n) || t.classList.remove(e)
              }))
            })), window.addEventListener("resize", (() => {
              window.innerWidth >= 835 && t.forEach((t => {
                t.classList.remove(e)
              }))
            }))
          },
          configMegamenus() {
            this.container.querySelectorAll(".header-megamenu").forEach((e => {
              var t = Number(e.querySelector("[data-total-columns]").dataset.totalColumns),
                r = {
                  defaultColumns: t <= 6 ? t : 6,
                  responsive: {
                    1023: t <= 5 ? t : 5,
                    833: t <= 4 ? t : 4
                  }
                };
              c(e.querySelector(".header-megamenu-items"), r)
            }))
          },
          addEventResize() {
            window.addEventListener("resize", debounce((() => {
              this.setCssProperties(), this.configResizeMobileMenu()
            }), 100))
          },
          addEventScroll() {
            window.addEventListener("scroll", debounce((() => {
              this.setCssProperties()
            }), 60))
          },
          onLoad() {
            this.mobileMediaQuery = 710, this.addClassToScroll(), this.addEventResize(), this.addEventScroll(), this.setCssProperties(), this.configSubmenuDesktop(), this.configMegamenus()
          }
        }), document.addEventListener("DOMContentLoaded", (() => {
          (0, n.zD)("*")
        })), r(4), document.addEventListener("DOMContentLoaded", (() => {
          (0, n.zD)("*")
        }))
      },
      4: () => {
        window.getImageMaxHeight = () => {
          var e = document.querySelectorAll(".product-card .product-card-image-wrapper");
          e.length && e.forEach((e => {
            e.style.setProperty("--height", "".concat(e.offsetHeight, "px"))
          }))
        }, window.getImageMaxHeight(), window.addEventListener("resize", window.getImageMaxHeight)
      }
    },
    t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.exports
  }
  r.m = e, r.x = e => {}, r.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return r.d(t, {
      a: t
    }), t
  }, r.d = (e, t) => {
    for (var n in t) r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
      enumerable: !0,
      get: t[n]
    })
  }, r.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), r.j = 348, (() => {
    var e = {
        348: 0
      },
      t = [
        [113, 351]
      ],
      n = e => {},
      o = (o, i) => {
        for (var s, a, [l, c, d, u] = i, h = 0, m = []; h < l.length; h++) a = l[h], r.o(e, a) && e[a] && m.push(e[a][0]), e[a] = 0;
        for (s in c) r.o(c, s) && (r.m[s] = c[s]);
        for (d && d(r), o && o(i); m.length;) m.shift()();
        return u && t.push.apply(t, u), n()
      },
      i = self.webpackChunkgetmore_workflow = self.webpackChunkgetmore_workflow || [];

    function s() {
      for (var n, o = 0; o < t.length; o++) {
        for (var i = t[o], s = !0, a = 1; a < i.length; a++) {
          var l = i[a];
          0 !== e[l] && (s = !1)
        }
        s && (t.splice(o--, 1), n = r(r.s = i[0]))
      }
      return 0 === t.length && (r.x(), r.x = e => {}), n
    }
    i.forEach(o.bind(null, 0)), i.push = o.bind(null, i.push.bind(i));
    var a = r.x;
    r.x = () => (r.x = a || (e => {}), (n = s)())
  })(), r.x()
})();


/* document.querySelectorAll('.product-section-tab-header-wrapper').forEach(tab => {
    tab.addEventListener('click', function() {
        document.querySelectorAll('.product-section-tab-header-wrapper').forEach(tab => {
            tab.classList.remove('active');
        });

        this.classList.add('active');

        const index = this.getAttribute('data-index');
        document.querySelectorAll('.product-section-tab-content').forEach(content => {
            content.classList.remove('active');
        });

        const contentToActivate = document.querySelector(`.product-section-tab-content[data-index='${index}']`);
        if (contentToActivate) {
            contentToActivate.classList.add('active');
        }
    });
}); */

document.querySelectorAll('.product-section-tab-header-wrapper').forEach(tab => {
  tab.addEventListener('click', function() {
      const parentContainer = this.closest('.product-section-tabs');
      if (!parentContainer) return;

      const tabs = parentContainer.querySelectorAll('.product-section-tab-header-wrapper');
      const contents = parentContainer.querySelectorAll('.product-section-tab-content');
      const index = this.getAttribute('data-index');

      tabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');

      contents.forEach(content => content.classList.remove('active'));
      const contentToActivate = parentContainer.querySelector(`.product-section-tab-content[data-index='${index}']`);
      if (contentToActivate) {
          contentToActivate.classList.add('active');
      }
  });
});


document.querySelectorAll('.product-simple-tab-header-wrapper').forEach(tab => {
    tab.addEventListener('click', function() {
        document.querySelectorAll('.product-simple-tab-header-wrapper').forEach(tab => {
            tab.classList.remove('active');
        });

        this.classList.add('active');
        
        const index = this.getAttribute('data-index');
        document.querySelectorAll('.product-simple-tab-content').forEach(content => {
            content.classList.remove('active');
        });

        const contentToActivate = document.querySelector(`.product-simple-tab-content[data-index='${index}']`);
        if (contentToActivate) {
            contentToActivate.classList.add('active');
        }
    });
});


/*window.onload = function() {
    setTimeout(function() {
        var headerContainer = document.querySelector(".header-main-wrapper");
        var filterFixed = document.querySelector(".boost-sd__filter-block .boost-sd__toolbar-container");

        if (headerContainer && filterFixed) {
          var headerHeight = headerContainer.offsetHeight;
          filterFixed.style.top = headerHeight + "px";
        }
    }, 100);
}*/